"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UploadState = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _groupBy = _interopRequireDefault(require("lodash/groupBy"));

var _filter = _interopRequireDefault(require("lodash/fp/filter"));

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

var _react = _interopRequireWildcard(require("react"));

var _Target = _interopRequireDefault(require("./Target"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var UploadState = {
  QUEUED: -1,
  UPLOADING: 0,
  FINISHED: 1
};
exports.UploadState = UploadState;

var isUploadPending = function isUploadPending(_ref) {
  var progress = _ref.progress;
  return progress == UploadState.QUEUED || progress == UploadState.UPLOADING;
};

var ImageUploader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(ImageUploader, _PureComponent);

  function ImageUploader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ImageUploader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ImageUploader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      uploads: []
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleUpload", function (file) {
      var onUpload = _this.props.onUpload;

      var index = _this.state.uploads.findIndex(function (upload) {
        return upload.file == file;
      });

      _this.setState(function (state) {
        return (0, _immutabilityHelper["default"])(state, {
          uploads: (0, _defineProperty2["default"])({}, index, {
            $merge: {
              progress: UploadState.UPLOADING,
              startTime: Date.now()
            }
          })
        });
      }, function () {
        var upload = onUpload(file);
        if (upload instanceof Promise) upload.then(_this.handleUploadSuccess(file))["catch"](_this.handleUploadError(file));
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleUploadSuccess", function (file) {
      return (
        /*#__PURE__*/
        (0, _asyncToGenerator2["default"])(
        /*#__PURE__*/
        _regenerator["default"].mark(function _callee() {
          var index;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  index = _this.state.uploads.findIndex(function (upload) {
                    return upload.file == file;
                  });

                  _this.setState(function (state) {
                    return (0, _immutabilityHelper["default"])(state, {
                      uploads: (0, _defineProperty2["default"])({}, index, {
                        $merge: {
                          progress: UploadState.FINISHED
                        }
                      })
                    });
                  });

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      );
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleUploadError", function (file) {
      return function (error) {
        var index = _this.state.uploads.findIndex(function (upload) {
          return upload.file == file;
        });

        _this.setState(function (state) {
          return (0, _immutabilityHelper["default"])(state, {
            uploads: (0, _defineProperty2["default"])({}, index, {
              $merge: {
                progress: UploadState.FINISHED,
                error: error
              }
            })
          });
        });
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onUpload",
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(files) {
        var filterFiles;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                filterFiles = _this.props.filterFiles;

                _this.setState(function (state) {
                  return (0, _immutabilityHelper["default"])(state, {
                    uploads: {
                      $push: filterFiles(files).map(function (file) {
                        return {
                          file: file,
                          progress: UploadState.QUEUED,
                          error: undefined
                        };
                      })
                    }
                  });
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2["default"])(ImageUploader, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var queueUploads = this.props.queueUploads;
      var uploads = this.state.uploads;

      if (uploads.length && uploads !== prevState.uploads) {
        var _objectSpread2;

        var uploadsByState = _objectSpread((_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, UploadState.QUEUED, []), (0, _defineProperty2["default"])(_objectSpread2, UploadState.UPLOADING, []), (0, _defineProperty2["default"])(_objectSpread2, UploadState.FINISHED, []), _objectSpread2), (0, _groupBy["default"])(uploads, 'progress'));

        var activeUploads = queueUploads - uploadsByState[UploadState.UPLOADING].length;

        if (activeUploads) {
          // Start queued uploads
          uploadsByState[UploadState.QUEUED].slice(0, activeUploads).map(function (_ref4) {
            var file = _ref4.file;
            return _this2.handleUpload(file);
          });
        }

        if (uploadsByState[UploadState.FINISHED].length == uploads.length) {
          // Clear uploads
          setTimeout(function () {
            return _this2.setState(function (state) {
              return (0, _immutabilityHelper["default"])(state, {
                uploads: {
                  $apply: (0, _filter["default"])(isUploadPending)
                }
              });
            });
          }, 1000);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement(_Target["default"], (0, _extends2["default"])({}, this.props, {
        progress: this.progress,
        onDrop: this.onUpload
      }));
    }
  }, {
    key: "progress",
    get: function get() {
      var uploads = this.state.uploads;
      var activeUploads = uploads.length;
      var pendingUploads = uploads.filter(isUploadPending).length;
      return activeUploads ? [activeUploads - pendingUploads, activeUploads] : undefined;
    }
  }]);
  return ImageUploader;
}(_react.PureComponent);

exports["default"] = ImageUploader;
(0, _defineProperty2["default"])(ImageUploader, "defaultProps", {
  queueUploads: 3,
  filterFiles: function filterFiles(files) {
    return files;
  }
});